<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75 5.65625C4.26777 5.65625 4.6875 5.23652 4.6875 4.71875C4.6875 4.20098 4.26777 3.78125 3.75 3.78125C3.23223 3.78125 2.8125 4.20098 2.8125 4.71875C2.8125 5.23652 3.23223 5.65625 3.75 5.65625Z"
      fill="#8CAFD3"
    />
    <path
      d="M7.5 4.71875C7.5 2.65103 5.81772 0.96875 3.75 0.96875C1.68228 0.96875 0 2.65103 0 4.71875C0 6.34975 0.69625 6.88306 1.74956 8.31953C3.19066 10.2829 3.34775 10.671 3.75 11.2812C4.03912 10.8427 4.36788 10.2032 5.75044 8.31953C6.80375 6.88306 7.5 6.34975 7.5 4.71875ZM3.75 6.59375C2.71591 6.59375 1.875 5.75284 1.875 4.71875C1.875 3.68466 2.71591 2.84375 3.75 2.84375C4.78409 2.84375 5.625 3.68466 5.625 4.71875C5.625 5.75284 4.78409 6.59375 3.75 6.59375Z"
      fill="#8CAFD3"
    />
    <path
      d="M11.2812 0H9.40625V11.2812H0V13.1562H9.40625V16H11.2812V13.1562H16V11.2812H11.2812V5.65625H16V3.78125H11.2812V0Z"
      fill="#8CAFD3"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
